export default __webpack_public_path__ + "static/screen-3-0c8c66090c91ad323ce93e9e9878c19a.png";